import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getTransaction = async (params) => {
  // Harendra remove next line
  return null
    try {
  return await get<ApiResponse<[]>>(`/wallet/fabric/transaction?${params}`).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
